import type { FC } from "react";
import React from "react";
import { styled } from "@mui/material/styles";

type LoadingOverlayProps = {
  loaded?: boolean;
  zIndex?: number;
};

const StyledLoader = styled("div")({
  position: "absolute",
  inset: 0,
  zIndex: "var(--z-loader)",
  backgroundColor: "#fff",
  opacity: 0.0,
  pointerEvents: "none",
  transition: "opacity 150ms linear",
});

/**
 * Provides an overlay for loading content.
 * Is permanently displayed but is transparent and does not capture mouse events.
 * Requires a positioning context.
 */
const LoadingOverlay: FC<LoadingOverlayProps> = ({ loaded, zIndex = 1 }) => {
  return (
    <StyledLoader
      role="progressbar"
      aria-busy={loaded ? "false" : "true"}
      aria-valuetext="loading"
      style={{ opacity: loaded ? 0.0 : 0.5, zIndex }}
    />
  );
};

export default LoadingOverlay;
